export enum RESULT_STATE_TONE {
  NEUTRAL = 'neutral',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}
export enum RESULT_STATE_SIZE {
  COMPACT = 'compact',
  DEFAULT = 'default',
}
export enum RESULT_STATE_PLACEMENT {
  INLINE = 'inline',
  SECTION = 'section',
  PAGE = 'page',
}
